import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
} from '@mui/material';
import { Line } from 'react-chartjs-2';
import { fetchMetrics } from '../services/api';

export default function Dashboard({ user }) {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMetrics = async () => {
      try {
        const data = await fetchMetrics();
        setMetrics(data);
      } catch (err) {
        console.error('Failed to fetch metrics:', err);
      } finally {
        setLoading(false);
      }
    };
    loadMetrics();
  }, []);

  if (loading) return <CircularProgress />;
  if (!metrics) return <Typography>Error loading data</Typography>;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography variant="h6">Total Revenue</Typography>
            <Typography variant="h4">
              ${metrics.totalRevenue.toLocaleString()}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography variant="h6">Active Customers</Typography>
            <Typography variant="h4">{metrics.activeCustomers}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography variant="h6">Pending Withdrawals</Typography>
            <Typography variant="h4">{metrics.pendingWithdrawals}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography variant="h6">System Health</Typography>
            <Typography variant="h4">{metrics.systemHealth}%</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h5">Revenue Trend (Last 30 Days)</Typography>
            <Line
              data={{
                labels: metrics.revenueChart.labels,
                datasets: [
                  {
                    label: 'Revenue ($)',
                    data: metrics.revenueChart.data,
                    borderColor: '#3b82f6',
                    tension: 0.1,
                    fill: false,
                  },
                ],
              }}
              options={{
                responsive: true,
                plugins: {
                  legend: { position: 'top' },
                  title: { display: false },
                },
              }}
              height={200}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
